import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { tokens } from '@neo4j-ndl/base';
import { forwardRef } from 'react';
import { getRadius, getSpacing, } from './types';
/**
 * Flex is a general-purpose container that helps
 * lay out components with consistent spacing in a row or column.
 */
export const Flex = forwardRef(function Flex({ as, gap = '4', rowGap, columnGap, children, borderRadius, flexDirection = 'column', flexWrap = 'nowrap', alignItems, justifyContent, className, style, htmlAttributes, }, ref) {
    const Component = (as || 'div');
    // If gap is not provided,
    // and rowGap and columnGap are not provided,
    // then use the default value.
    const gapPx = getSpacing(gap, 'gap');
    const rowGapPx = rowGap ? tokens.space[rowGap] : undefined;
    const columnGapPx = columnGap ? tokens.space[columnGap] : undefined;
    const gapFormatted = `${rowGapPx !== null && rowGapPx !== void 0 ? rowGapPx : gapPx} ${columnGapPx !== null && columnGapPx !== void 0 ? columnGapPx : gapPx}`;
    const additionalStyle = {
        flexDirection,
        alignItems,
        flexWrap,
        justifyContent,
        display: 'flex',
        gap: gapFormatted,
        borderRadius: getRadius(borderRadius, 'borderRadius'),
    };
    return (_jsx(Component, Object.assign({ ref: ref, className: className, style: Object.assign(Object.assign({}, additionalStyle), style) }, htmlAttributes, { children: children })));
});
//# sourceMappingURL=Flex.js.map